export const HANDLE_STORY_MOMENT_CHANGED = 'HANDLE_STORY_MOMENT_CHANGED';
